module.exports = __webpack_public_path__ + "static/media/in-the-wake-of-the-hurricane.03fbefc4.jpg";